import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { map, Observable, of } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class NotInActiveGuard implements CanActivate {

  constructor(private commonService: CommonService, private router: Router) { }

  canActivate(): Observable<boolean> {
    // Get account from localStorage
    const accountString = localStorage.getItem('account');

    if (!accountString) {
      this.router.navigate(['/login']);
      return of(false);
    }

    const accountInfo: Account = JSON.parse(accountString);

    if (!accountInfo?.id) {
      this.router.navigate(['/login']);
      return of(false);
    }

    return this.commonService.getInActiveStatus(accountInfo.id).pipe(
      map((inActive: boolean) => {
        if (!inActive) {
          // Account is NOT inactive, redirect to appropriate page
          if (accountInfo.isSuperUser) {
            this.router.navigate(['/dashboard']);
            return false;
          }
          if (accountInfo.supervisorMode) {
            this.router.navigate(['/home']);
            return false;
          }
          // All non-superusers go to home
          this.router.navigate(['/home']);
          return false;
        }
        // Account IS inactive, allow access to inactive page
        return true;
      })
    );
  }
}
